module.exports = __webpack_public_path__ + "img/4.9be7c7c8.png";